import { ROUTE_DASHBOARD_PROFILE, ROUTE_DASHBOARD_TEAMS_PAGE } from '@/constants/routes';
import useApplicationConfig from '@/hooks/useApplicationConfig';
import useAuth from '@/hooks/useAuth';
import {
	Avatar,
	Box,
	Button,
	Center,
	Flex,
	HStack,
	Heading,
	IconButton,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
	Text,
	Tooltip,
	VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiBell, FiMenu, FiUser, FiUsers } from 'react-icons/fi';
import { useHistory } from 'react-router-dom';

interface IShellHeaderProps {
	onOpen: () => void;
	hideLogoInLg?: boolean;
}
export default function ShellHeader(props: IShellHeaderProps) {
	const history = useHistory();
	const auth = useAuth();
	const { t } = useTranslation();
	const applicationConfig = useApplicationConfig();

	if (!auth.getCurrentUser()) {
		return null;
	}

	return (
		<Box bg="white" borderBottomWidth="1px" borderBottomColor="gray.200">
			<Box
				display="flex"
				px={{ base: 4, lg: 6 }}
				height="16"
				alignItems="center"
				justifyContent={{ base: 'space-between', lg: 'flex-end' }}
			>
				<IconButton
					mr={4}
					display={{ base: 'flex', lg: 'none' }}
					onClick={props.onOpen}
					variant="outline"
					aria-label="open menu"
					icon={<FiMenu />}
				/>

				<Heading
					mr="auto"
					display={{ base: 'flex', lg: props.hideLogoInLg ? 'none' : 'flex' }}
					fontSize="xl"
					fontWeight={900}
					color="primary.500"
				>
					{applicationConfig.name}
				</Heading>

				<HStack spacing={{ base: '0', lg: '4' }}>
					<Tooltip label={t('No new notifications')} placement="bottom-start" hasArrow>
						<IconButton mr={2} size="lg" variant="ghost" aria-label="open menu" icon={<FiBell />} />
					</Tooltip>

					<Flex alignItems={'center'}>
						<Menu>
							<MenuButton as={Button} rounded={'full'} variant={'link'} cursor={'pointer'} minW={0}>
								<Avatar borderWidth={1} borderColor="gray.200" size={'sm'} src={auth.getCurrentUser().imageSrc} />
							</MenuButton>
							<MenuList alignItems={'center'}>
								<Box p={6}>
									<Center>
										<Avatar borderWidth={1} borderColor="gray.200" size={'lg'} src={auth.getCurrentUser().imageSrc} />
									</Center>
									<VStack mt={4}>
										<Text fontWeight={500}>{auth.getCurrentUser().username}</Text>
										<Text fontSize="sm" color="gray.600">
											{auth.getCurrentUser().email}
										</Text>
									</VStack>
								</Box>
								<MenuDivider />
								<MenuItem icon={<FiUser />} onClick={() => history.push(ROUTE_DASHBOARD_PROFILE)}>
									<Text>{t('Profile')}</Text>
								</MenuItem>
								<MenuItem icon={<FiUsers />} onClick={() => history.push(ROUTE_DASHBOARD_TEAMS_PAGE)}>
									<Text>{t('Teams')}</Text>
								</MenuItem>
							</MenuList>
						</Menu>
					</Flex>
				</HStack>
			</Box>
		</Box>
	);
}
